// 婴儿监视器

export default [
    {
        path: '/babyMonitorIndex',
        name: 'babyMonitorIndex',
        component: () => import('@/views/babyMonitorSystem/index'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/babyMonitorMachineList',
        name: 'babyMonitorMachineList',
        component: ()=>import('@/views/babyMonitorSystem/deviceManage/machineList'),
        meta: {
            title: '机型管理'
        }
    },
    {
        path: '/babyMonitorAddModelPage',
        name: 'babyMonitorAddModelPage',
        meta: {
            title: '新增机型'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/addModelPage')
    },{
        path: '/babyMonitorEditModelPage',
        name: 'babyMonitorEditModelPage',
        meta: {
            title: '编辑机型'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/editModelPage')
    },{
        path: '/babyMonitorCheckModel',
        name: 'babyMonitorCheckModel',
        meta: {
            title: '查看机型'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/checkModel')
    },
    {
        path: '/babyMonitorOtaManger',
        name: 'babyMonitorOtaManger',
        component: () => import('@/views/babyMonitorSystem/apply/otaManger'),
        meta: {
            title: 'OTA管理'
        }
    },{
        path: '/babyMonitorAppManager',
        name: 'babyMonitorAppManager',
        component: () => import('@/views/babyMonitorSystem/apply/appManager'),
        meta: {
            title: 'APP管理'
        }
    }
    ,{
        path: '/babyMonitorOtaUpdateAddPage',
        name: 'babyMonitorOtaUpdateAddPage',
        meta: {
            title: 'OTA新增'
        },
        component: () => import('@/views/babyMonitorSystem/apply/otaUpdateAddPage')
    },{
        path: '/babyMonitorOtaUpdateEditPage',
        name: 'babyMonitorOtaUpdateEditPage',
        meta: {
            title: 'OTA编辑'
        },
        component: () => import('@/views/babyMonitorSystem/apply/otaUpdateEditPage')
    },{
        path: '/babyMonitorAppUpdateAddPage',
        name: 'babyMonitorAppUpdateAddPage',
        meta: {
            title: 'App新增'
        },
        component: () => import('@/views/babyMonitorSystem/apply/appUpdateAddPage')
    },{
        path: '/babyMonitorAppUpdateEditPage',
        name: 'babyMonitorAppUpdateEditPage',
        meta: {
            title: 'App编辑'
        },
        component: () => import('@/views/babyMonitorSystem/apply/appUpdateEditPage')
    },{
        path: '/babyMonitorApkUpdateAddPage',
        name: 'babyMonitorApkUpdateAddPage',
        meta: {
            title: 'Apk新增'
        },
        component: () => import('@/views/babyMonitorSystem/apply/apkUpdateAddPage')
    },{
        path: '/babyMonitorApkUpdateEditPage',
        name: 'babyMonitorApkUpdateEditPage',
        meta: {
            title: 'Apk编辑'
        },
        component: () => import('@/views/babyMonitorSystem/apply/apkUpdateEditPage')
    },{
        path: '/babyMonitorApkManager',
        name: 'babyMonitorApkManager',
        meta: {
            title: 'APK管理'
        },
        component: () => import('@/views/babyMonitorSystem/apply/apkManager')
    }
    ,{
        path: '/babyMonitorOtaDownloadLogs',
        name: 'babyMonitorOtaDownloadLogs',
        component: () => import('@/views/babyMonitorSystem/apply/otaDownloadLogs'),
        meta: {
            title: 'OTA升级记录'
        }
    },{
        path: '/babyMonitorDeviceAppExclude',
        name: 'babyMonitorDeviceAppExclude',
        component: () => import('@/views/babyMonitorSystem/apply/deviceAppExclude'),
        meta: {
            title: 'APP黑名单'
        }
    },{
        path: '/babyMonitorDeviceInstruction',
        name: 'babyMonitorDeviceInstruction',
        component: () => import('@/views/babyMonitorSystem/deviceManage/deviceInstruction'),
        meta: {
            title: '设备指令'
        }
    },{
        path: '/babyMonitorImeiErrorLogList',
        name: 'babyMonitorImeiErrorLogList',
        component: () => import('@/views/babyMonitorSystem/deviceManage/imeiErrorLogList'),
        meta: {
            title: '设备日志'
        }
    },
    {
        path: '/babyMonitorDeviceList',
        name: 'babyMonitorDeviceList',
        meta: {
            title: '设备中心'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/deviceList')
    },
    {
        path: '/babyMonitorUserList',
        name: 'babyMonitorUserList',
        component: () => import('@/views/babyMonitorSystem/appUser/userList'),
        meta: {
            title: '用户管理'
        }
    },
    {
        path: '/babyMonitorUserLoginLog',
        name: 'babyMonitorUserLoginLog',
        component: () => import('@/views/babyMonitorSystem/appUser/userLoginLog'),
        meta: {
            title: '用户登录日志'
        }
    },
    {
        path: '/babyMonitorUserMonthRegister',
        name: 'babyMonitorUserMonthRegister',
        component: () => import("@/views/babyMonitorSystem/bi/userMonthRegister"),
        meta: {
            title: '用户统计'
        }
    },
    {
        path: '/babyMonitorDeviceMonthRegister',
        name: 'babyMonitorDeviceMonthRegister',
        component: () => import("@/views/babyMonitorSystem/bi/deviceMonthRegister"),
        meta: {
            title: '设备统计'
        }
    },
    {
        path: '/babyMonitorFeedbackList',
        name: 'babyMonitorFeedbackList',
        component: () => import('@/views/babyMonitorSystem/feedback/maskFeedbackList'),
        meta: {
            title: '用户反馈'
        }
    },
    {
        path: '/babyMonitorChannelAppPage',
        name: 'babyMonitorChannelAppPage',
        component: () => import('@/views/babyMonitorSystem/deviceManage/ChannelAppPage'),
        meta: {
            title:'渠道APP管理'
        }
    },
    {
        path: '/babyMonitorChannelList',
        name: 'babyMonitorChannelList',
        component: () => import('@/views/babyMonitorSystem/deviceManage/channelList'),
        meta: {
            title: '渠道管理'
        }
    },
    {
        path: '/babyMonitorVirtualSnLicenseList',
        name: 'babyMonitorVirtualSnLicenseList',
        meta: {
            title: '授权许可'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/virtualSnLicenseList'),
    }, {
        path: '/babyMonitorVirtualSnBatchList',
        name: 'babyMonitorVirtualSnBatchList',
        meta: {
            title: '授权批次'
        },
        component: () => import('@/views/babyMonitorSystem/deviceManage/virtualSnBatchList'),
    },


]



// WEBPACK FOOTER //
// ./src/router/babyMonitorRouter.js